import React from 'react';
import AdminLayout from './AdminLayout';
import Dashboard from './Dashboard/Dashboard';

const Admin = () => {
  return (
    <AdminLayout>
      <Dashboard />
    </AdminLayout>
  );
};

export default Admin;
